import ReceiptModule from "@/store/modules/receipt";
import {
  getReceiptCounter,
  patchExactReceiptCounter,
} from "@/api/receipt-counter/receipt-counter";
import { LogService } from "@/services/logging";
import { CounterStatus } from "@/types/db/transaction";

/**
 * Called every 5 minutes and when sales closure to check for issues with the receipt counter.
 * It checks: Counter in State vs Remote Counter
 * It tries to patch the counter if it is not in sync.
 */
export async function monitorReceiptSynchingIssues() {
  console.log("----------- hi from monitorReceiptSynchingIssues");
  if (!ReceiptModule.receiptCounter) {
    LogService.info(
      `Receipt Counter: Montiroing - device does not have a set receiptCounter stored in app state.`
    );
    return;
  }

  const currentStateCounter = ReceiptModule.receiptCounter;

  const payload = {
    groupId: String(currentStateCounter.groupId),
    reference: currentStateCounter.reference,
  };
  try {
    const currrentRemoteCounter = await getReceiptCounter(payload);
    const remoteCounterValue = currrentRemoteCounter?.value;
    const currentStateCounterValue = currentStateCounter.value;
    if (remoteCounterValue === currentStateCounterValue) {
      // Counters are in sync
      LogService.info(
        `Receipt Counter: Montiroing - remote receipt counter is in synch with local receipt counter for groupId ${payload.groupId} and reference ${payload.reference}.`
      );
      return;
    }

    if (remoteCounterValue < currentStateCounterValue) {
      // Remote counter is less than the current state counter
      // This means that the remote counter is not in sync with the current state counter
      // This means there is missing counter not synched
      // Lets Log this info and try to synch it now
      LogService.info(
        `Receipt Counter: Montiroing ALERT - local receipt counter is greater than remote receipt counter for groupId ${payload.groupId} and reference ${payload.reference}. Local: ${currentStateCounterValue}, Remote: ${remoteCounterValue}. Attempting to PATCH remote counter.`
      );

      try {
        const newReceiptCounter = await patchExactReceiptCounter({
          groupId: payload.groupId,
          reference: payload.reference,
          value: currentStateCounterValue,
          status: CounterStatus.Active,
        });
        LogService.info(
          `Receipt Counter: Monitoring - Successfully patched remote receipt counter for groupId ${payload.groupId} and reference ${payload.reference}. New value: ${newReceiptCounter.value}`
        );
      } catch (err) {
        LogService.info(
          `Receipt Counter: Monitoring - Error patching remote receipt counter for groupId ${payload.groupId} and reference ${payload.reference}`,
          {
            err,
          }
        );
      }
    }

    if (remoteCounterValue > currentStateCounterValue) {
      // Remote counter is greater than the local counter
      // This should never happen, unless the remote counter of this machine was updated by another machine or by a human being
      // We do nothing but we Alert
      LogService.info(
        `Receipt Counter: Montiroing ALERT - local receipt counter is less than remote receipt counter for groupId ${payload.groupId} and reference ${payload.reference}. Local: ${currentStateCounterValue}, Remote: ${remoteCounterValue}. This can only happen if remote receipt counter of this machine is updated by a human being or by another machine.`
      );
    }
  } catch (err) {
    LogService.info(
      `Receipt Counter: Montiroing - Error fetching remote receipt counter for monitoring for groupId ${payload.groupId} and reference ${payload.reference}`,
      {
        err,
      }
    );
  }
}
